import classNames from 'classnames';
import React, { Fragment, useContext } from 'react';
import { Portal } from '../../Layout';
import { DropdownContext } from './DropdownContext';
import styles from './DropdownMenu.module.css';

export type DropdownMenuProps = {
  isAbsolute?: boolean;
} & React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>;

const DropdownMenu = ({
  isAbsolute,
  children,
  className,
  style,
  ...props
}: DropdownMenuProps) => {
  const { coords, menuRef, hideMenu, show, usePortal } =
    useContext(DropdownContext);

  const classname = classNames(
    styles.container,
    {
      [styles.show]: show,
      [styles.absolutely]: isAbsolute,
    },
    className,
  );

  const dropdownStyle = {
    ...style,
    top: coords.top,
    left: coords.left,
  };

  const Wrapper = usePortal ? Portal : Fragment;

  return (
    <Wrapper>
      <div
        {...props}
        className={classname}
        ref={menuRef}
        style={dropdownStyle}
        onClick={hideMenu}
      >
        {children}
      </div>
    </Wrapper>
  );
};

export default DropdownMenu;
